import CoreErrorCodesLocale from '../locale/en/core-error-codes.json';

export const getErrorMessage = (
  code,
  defaultMessage = CoreErrorCodesLocale.UNKNOWN,
) => {
  return CoreErrorCodesLocale[code] || defaultMessage;
};

export const SeedError = class extends Error {
  errorCode: string;
  httpStatusCode: number | null;
  constructor(
    errorCode: string,
    message: string,
    httpStatusCode: number | null = null,
  ) {
    super(message);
    Error.captureStackTrace(this, this.constructor);
    this.name = this.constructor.name;
    this.errorCode = errorCode;
    this.httpStatusCode = httpStatusCode;
  }
};

export const UnexpectedError = class extends Error {
  httpResponse: Response | null;
  httpStatusCode: number | undefined;
  constructor(message: string, httpResponse: Response | null = null) {
    super(message);
    Error.captureStackTrace(this, this.constructor);
    this.name = this.constructor.name;
    this.httpResponse = httpResponse;
    this.httpStatusCode = httpResponse?.status;
  }
};
